module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section3-498.82ce4df0.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/section3-498.82ce4df0.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/section3-498.82ce4df0.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section3-498.82ce4df0.webp"},
        
        width: 498,
        height: 498
      }